const ja = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '没入型の地理ゲーム7本。',
  'home.subtitle.line2':  '1つの地球。5つのレベル。終わらない驚き。',
  'home.tagline.line1':   '7つのゲーム、ひとつの惑星。',
  'home.tagline.line2':   '地球のあらゆる隅を発見しよう — 競い、ポイントを稼ぎ、自分の帝国を築け。',
  'home.footer.company':  '会社',
  'home.footer.legal':    '法的情報',
  'home.footer.about':    'About us',
  'home.footer.contact':  'お問い合わせ',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'プライバシー',
  'home.footer.terms':    '利用規約',
  'home.footer.cookies':  'Cookie',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Android アプリの早期テスターに参加しよう',
  'home.beta.text':       'Founder バッジ、ライフタイム Premium、上記の抽選賞品のチャンスをゲット。',
  'home.beta.cta':        'BETA プログラム',

  'common.start':         'スタート',
  'common.startBig':      '▶ スタート',
  'common.back':          '戻る',
  'common.home':          'ホーム',
  'common.howToPlay':     '遊び方',
  'common.gotIt':         '了解 — ゲームに戻る',
  'common.next':          '次へ',
  'common.restart':       'やり直す',
  'common.tryAgain':      'もう一度',
  'common.playAgain':     'もう一度プレイ',
  'common.mainMenu':      'メインメニュー',
  'common.quit':          '終了',
  'common.play':          'プレイ',
  'common.unlock':        '🔒 Premium で解放',
  'common.language':      '言語',

  'rules.kicker.goal':         '目的',
  'rules.kicker.howToPlay':    '遊び方',
  'rules.kicker.levels':       'レベル',
  'rules.kicker.tips':         'ヒント',
  'rules.gameNotFound':        'ゲームが見つかりません',
  'rules.points':              'pt',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'ルーツを探せ',
  'games.origin.description': '世界のどこかのランダムなストリートビューに降ろされる。地図上で正確に自分の位置を示そう。5レベルで100 km → 1 kmの精度。',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS型トレジャーハント',
  'games.hunt.description':   '実在のランドマーク近くに配置される。ストリートビューを歩いて辿り着こう。レベルが上がるほどコンパスは頼れなくなる。',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      '手がかりを読み解け',
  'games.photo.description':  '一枚の静止ストリートビュー画像 — パンも動きもなし。看板、植物、太陽の向きを読む。30秒から5秒のフラッシュまで。',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    '地球を組み直せ',
  'games.pangaea.description':'3D地球の周りに大陸と島が浮遊している。本来の位置に戻そう — 現代の位置か、古代パンゲアか。',

  'rules.origin.goal': '地球上のランダムなストリートビューに降ろされます。世界地図上に、できるだけ正確に自分を示しましょう。',
  'rules.origin.step1': 'パノラマを見渡す。看板を読み、車線を数え、空を見て太陽の向きを確かめる。',
  'rules.origin.step2': 'ミニマップをクリックして、自分がいると思う場所にピンを立てる。',
  'rules.origin.step3': '送信。ピンが実際の場所に近いほど高得点。',
  'rules.origin.step4': 'レベルは連鎖する — 距離のしきい値を超えると次に進める。',
  'rules.origin.level1': '100 km以内',
  'rules.origin.level2': '50 km以内',
  'rules.origin.level3': '25 km以内',
  'rules.origin.level4': '10 km以内',
  'rules.origin.level5': '1 km以内',
  'rules.origin.tip1': '走行レーン、ナンバープレートの形式、道路標示の色から国がすぐわかる。',
  'rules.origin.tip2': '植生 + 太陽の高さで緯度が絞れる。通り名の標識で都市が確定する。',
  'rules.origin.tip3': 'Master Geographer(L5 = 1 km)は過酷 — ほとんどのランはL3かL4で終わる。',

  'rules.hunt.goal': 'ストリートビューで実在のランドマーク近くに置かれます。パノラマを歩いて、その上に立つまで進みましょう。レベルが上がるほどコンパスの助けは減ります。',
  'rules.hunt.step1': '上部バーで目標の名前を確認。',
  'rules.hunt.step2': 'コンパスの矢印 + 距離表示で方向を合わせる。',
  'rules.hunt.step3': '矢印をクリックしてストリートビューを歩く。',
  'rules.hunt.step4': '発見ゾーン内に入ると「みつけた!」ボタンが有効になる — 押して得点。',
  'rules.hunt.level1': '5 km · 10分 · 世界的有名 · 矢印+正確距離 · 100 m発見ゾーン',
  'rules.hunt.level2': '15 km · 12分 · 世界的有名 · 矢印+概算距離',
  'rules.hunt.level3': '25 km · 12分 · 国内で有名 · コンパスのみ、距離なし',
  'rules.hunt.level4': '50 km · 15分 · 国内で有名 · 近い/遠い表示',
  'rules.hunt.level5': '50 km · 10分 · マイナー · POI名のみ、GPSなし',
  'rules.hunt.tip1': 'L4–L5ではCompass Ping 3回 — 矢印の点滅、慎重に使うこと。',
  'rules.hunt.tip2': '中間チェックポイントボーナス: 半分まで来ると+2分。',
  'rules.hunt.tip3': '名前だけのときは記憶や周囲を観察 — 多くのランドマークは遠くからでも識別できる。',

  'rules.photo.goal': '一枚の静止ストリートビュー画像 — パンも動きもなし。看板、植物、太陽の向き、道路標示から、地球上のどこかを推理する。',
  'rules.photo.step1': '最初に地域を選ぶ(世界、ヨーロッパ、アジアなど) — 探索範囲が決まる。',
  'rules.photo.step2': '写真は決まった観察時間だけ表示される。一秒も無駄にしない。',
  'rules.photo.step3': 'タイマー終了で地図が出る。最善の推測でピンを立てる。',
  'rules.photo.step4': '近いほど高得点。結果画面で写真を再生して見逃したものを確認。',
  'rules.photo.level1': '30秒の観察 · 精度1 000 km',
  'rules.photo.level2': '20秒 · 500 km',
  'rules.photo.level3': '15秒 · 250 km',
  'rules.photo.level4': '10秒 · 100 km',
  'rules.photo.level5': '5秒のフラッシュ · 50 km',
  'rules.photo.tip1': '看板の言語が最速の手がかり。一語で国がわかることが多い。',
  'rules.photo.tip2': '太陽の向きは南(北半球)または北(南半球)を示す。',
  'rules.photo.tip3': '電柱の形、道路標示、ナンバープレートは意外なほど決定的。',

  'rules.pangaea.goal': '3Dの地球と6つの大陸。レベルの角度許容範囲内に配置 — 現代の位置か、3億年前のパンゲアか。',
  'rules.pangaea.step1': '右側のリストから大陸を選ぶ。',
  'rules.pangaea.step2': '地球上の正しいと思う場所をクリック。',
  'rules.pangaea.step3': '許容範囲内 → スナップで定着。範囲外 → 赤フィードバック、再挑戦。',
  'rules.pangaea.step4': '大陸ごとに3回まで挑戦。6つ中5つ以上で次レベルへ。',
  'rules.pangaea.level1': '大陸 · 現代 · 25°許容',
  'rules.pangaea.level2': '現代 · 18°許容',
  'rules.pangaea.level3': '現代 · 12° 精密',
  'rules.pangaea.level4': 'パンゲア · 古代 · 25°許容',
  'rules.pangaea.level5': 'パンゲア · 古代 · 18° 精密',
  'rules.pangaea.tip1': '地球をドラッグして回転、スクロールでズーム。',
  'rules.pangaea.tip2': 'パンゲア時代、大陸は南半球に集まっていた — アフリカと南アメリカは合体し、インドは東アフリカに、北アメリカはヨーロッパに密着していた。',
  'rules.pangaea.tip3': '南極は赤道近くにあった。オーストラリアはその下にしがみついていた。',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'ランドマークを見抜け',
  'games.landmark.description':    '有名な建物や記念碑の写真 — それを見て、世界地図上にピンを置こう。永久無料。',
  'rules.landmark.goal':           '有名な建物の写真が出てくる。世界地図上のどこにあると思うかピンを置こう。',
  'rules.landmark.step1':          '数秒間写真を見る。建物を認識し、背景情報を読み取る。',
  'rules.landmark.step2':          'タイマーが終わると世界地図が表示される。',
  'rules.landmark.step3':          'ピンを置いて送信。近いほど高得点。',
  'rules.landmark.step4':          '5 レベル。レベルごとに時間と許容距離が短くなる。',
  'rules.landmark.level1':         '30 秒の観察 · 精度 1 000 km',
  'rules.landmark.level2':         '20 秒 · 500 km',
  'rules.landmark.level3':         '15 秒 · 250 km',
  'rules.landmark.level4':         '10 秒 · 100 km',
  'rules.landmark.level5':         '5 秒のフラッシュ · 50 km',
  'rules.landmark.tip1':           '特徴的な形(エッフェル、ピラミッド)は一瞬でわかる — 得点は正確なピン位置から。',
  'rules.landmark.tip2':           'マイナーなランドマーク: 背景を読む — 気候、建築様式、周辺。',
  'rules.landmark.tip3':           '写真は Wikipedia の CC-BY-SA。クレジットチップをタップで出典。',

  'paywall.title':        "このゲームはPremiumです",
  'paywall.text':         "プレイして貯めたポイントでこのゲームをアンロックできます。",
  'paywall.cta':          "BETAプログラムに参加",
  'paywall.dismiss':      "あとで",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "選択式クイズ",
  'games.spot.description': "有名な建物や記念碑の写真 — 3〜6個の選択肢から正解を選ぼう。無限モード、ラウンドごとに難しくなる。永久無料。",

  'rules.spot.goal':   "写真を見て正しいランドマークを選ぼう。間違えるとランは終了。",
  'rules.spot.step1':  "地域を選ぶ(世界・ヨーロッパ・アジア…) — プールがその大陸に絞られる。",
  'rules.spot.step2':  "有名なランドマーク写真と問題が表示される。",
  'rules.spot.step3':  "選択肢から正解をタップ。",
  'rules.spot.step4':  "連続を続けよう — レベルごとに選択肢が増え(最大6)、難しくなる。",
  'rules.spot.level1': "L1–L3 · 3〜5択 · 名前のみ",
  'rules.spot.level2': "L4+ · 6択 · 名前のみ",
  'rules.spot.level3': "L10+ · 6択 · 名前+国",
  'rules.spot.level4': "L20+ · 6択 · 名前+都市+国",
  'rules.spot.level5': "無限 · 深さでスコアが伸びる · 1ミスで終了",
  'rules.spot.tip1':   "ダミーは同じ大陸から来る — よく読もう。",
  'rules.spot.tip2':   "象徴的な形(エッフェル、ピラミッド)は楽勝 — 点は深さから。",
  'rules.spot.tip3':   "L10からは国も、L20からは都市も加わる。",

  "spot.region.title": "どこでプレイ?",
  "spot.region.sub": "地域を選ぼう。有名なランドマークが出題される — 正解を選ぼう。",
  "spot.q.name": "これは何のランドマーク?",
  "spot.q.namecountry": "名前+国?",
  "spot.q.namecity": "名前+都市+国?",
  "spot.score": "スコア",
  "spot.choices": "択",
  "spot.correct": "正解",
  "spot.wrong": "不正解",
  "spot.points": "ポイント",
  "spot.runTotal": "ラン合計",
  "spot.next": "次へ →",
  "spot.youPicked": "あなたの選択",
  "spot.finalScore": "最終スコア",
  "spot.reachedLevel": "到達レベル",
  "spot.tryAgain": "もう一度 ↺",
  "spot.changeRegion": "地域変更",
  "spot.mainMenu": "メインメニュー",

  /* ─── Auth ─── */
  "auth.signIn": "ログイン",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "ログインまたはアカウント作成",
  "auth.subtitle": "パスワード不要 — メールでマジックリンクを送ります。初回は自動でアカウント作成。",
  "auth.send": "マジックリンク送信",
  "auth.sending": "送信中…",
  "auth.invalidEmail": "有効なメールアドレスを入力してください。",
  "auth.sendFailed": "リンクを送信できませんでした。再試行してください。",
  "auth.checkInbox": "受信箱を確認",
  "auth.linkSentTo": "ログインリンクの送信先:",
  "auth.spamHint": "見つからない?迷惑メールも確認。リンクは1時間で失効。",
  "auth.gotIt": "OK",
  "auth.fineprint": "続行することで利用規約とプライバシーポリシーに同意します。",
  "auth.menu.profile": "マイプロフィール",
  "auth.menu.admin": "管理",
  "auth.menu.signOut": "ログアウト",
  "auth.callback.signingIn": "ログイン中…",
  "auth.callback.hold": "少々お待ちを。",
  "auth.callback.welcome": "ようこそ",
  "auth.callback.redirecting": "ゲームに戻ります…",
  "auth.callback.problem": "問題が発生しました",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "マイプロフィール",
  "profile.totalPoints": "総ポイント",
  "profile.totalRuns": "プレイ回数",
  "profile.gamesPlayed": "試したゲーム",
  "profile.editTitle": "プロフィール編集",
  "profile.displayName": "表示名",
  "profile.avatar": "アバター",
  "profile.country": "国 (任意)",
  "profile.countryHint": "2文字の国コード(例: JP, US, HU)。リーダーボードの旗用。",
  "profile.save": "保存",
  "profile.saving": "保存中…",
  "profile.saved": "保存しました",
  "profile.nameTooShort": "表示名は2文字以上にしてください。",
  "profile.perGame": "ゲーム別ベスト",
  "profile.noRuns": "まだプレイしていません — メニューに戻ってゲームを選んでください。",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "ロック中",
  "common.needPoints": "{n}pt必要",
  "locked.pill": "ロック中",
  "locked.title": "{game}はロック中",
  "locked.text": "{game}解放まであと{remaining}pt。利用可能なゲームをプレイして集めよう。",
  "locked.dismiss": "OK",
  "spot.anon.playsLeft": "無料プレイ残り{n}回 — ログインで継続。",
  "spot.anon.title": "無料プレイを使い切りました",
  "spot.anon.text": "{limit}回中{used}回プレイ済み。ログインで継続 — 無料、パスワード不要、メールのマジックリンクだけ。",
  "spot.anon.signIn": "ログインして続ける →",
  "spot.anon.back": "メニューに戻る",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "次のゲーム",
  "rules.next.unlocked": "次のゲーム — 解放済み",
  "rules.next.unlockedHint": "ポイントは十分 — メニューに戻ってプレイしよう。",
  "rules.next.needMore": "解放まであと{remaining}pt — このゲームを続けて稼ごう。",
  "rules.next.signedOut": "解放には{threshold}ptが必要 — ログインで集計開始。",
  "rules.next.premiumHint": "Premiumで解放 — Androidベータと共に。",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "旗+国歌",
  'games.audio.description': "国歌が流れ、その国の旗が表示される。首都に地図上でピンを。",

  'rules.audio.goal':   "国歌が流れ、旗が表示される。世界地図上の首都にできるだけ正確にピンを置こう。",
  'rules.audio.step1':  "地域を選ぶ。プールがその大陸に絞られる。",
  'rules.audio.step2':  "国歌が自動再生。旗は表示されたまま。",
  'rules.audio.step3':  "タイマー0で地図表示。首都にピンを置こう。",
  'rules.audio.step4':  "距離しきい値内なら通過。レベルが上がるほど短く。",
  'rules.audio.level1': "10秒 · 1,000 km以内",
  'rules.audio.level2': "8秒 · 500 km",
  'rules.audio.level3': "6秒 · 250 km",
  'rules.audio.level4': "4秒 · 100 km",
  'rules.audio.level5': "3秒フラッシュ · 50 km",
  'rules.audio.tip1':   "旗の識別は易しい — 首都を正確に置くのが本当の課題。",
  'rules.audio.tip2':   "最大都市が首都とは限らない(ブラジリア、キャンベラ、オタワ、プレトリア)。",
  'rules.audio.tip3':   "国歌のテンポと楽器編成も手がかり。",

  "audio.region.title": "どこで聴く?",
  "audio.region.sub": "地域を選ぼう。国歌が流れ、国旗が表示される — 地図上の首都にピンを置こう。",
  "audio.empty.title": "まだ音声クリップなし",
  "audio.empty.text": "まだ国歌は利用できません — 選曲を準備中です。新しい国を当てるために、またチェックしてください。",
  "audio.listen.hint": "旗と国歌が分かる?首都に地図上でピンを置こう。",
  "audio.listen.skip": "十分わかった →",
  "audio.submit.ready": "送信 →",
  "audio.submit.empty": "地図をクリックしてピンを置く",
  "audio.changeRegion": "地域変更",

  /* ─── Empire ─── */
  "profile.empire.title": "私の帝国",
  "profile.empire.empty": "Audio AtlasかLandmark Quizで国を当てると獲得。正解するたびに帝国が広がる。",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "グラインドをスキップ",
  "boost.tagline": "ポイント購入で解放を早める",
  "boost.description": "待ちたくない?3パック €2.99から。ポイントは即時加算、すべての解放にカウント。",
  "boost.cta": "ポイントを買う",
  "shop.title": "ポイントショップ",
  "shop.sub": "グラインドをスキップ",
  "shop.buy": "購入",
  "shop.opening": "オープン中…",
  "shop.success": "支払い確認 — ポイントは数秒で加算されます。",
  "shop.cancel": "キャンセル済み — 課金はありません。",
  "shop.fineprint": "Stripe経由の単発購入。確認後すぐ加算。サブスクリプションなし。",
  "shop.boost.badge": "人気",
  "shop.power.badge": "お得",

  /* ─── Boost / Shop ─── */
};

export default ja;
